import React, { PureComponent, useEffect, useState } from 'react';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//datefomatter
import { format } from 'date-fns';
//chart
import { Area, Bar, CartesianGrid, ComposedChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
//store
import useComnStore from 'src/webapp/stores/comn.store';
import usePartnerStore from 'src/webapp/stores/partner.store';
//style
import styles from 'src/asset/scss/style/dashboard.module.scss';

export default React.memo(function LineChart(props) {
  const { axiosPostHandler } = useAxiosHook();//axios
  const { startDate, endDate } = props;//props
  const { socket } = useComnStore();
  const { isState, partner } = usePartnerStore();

  /* =============== 기간별 매출통계 =============== */
  const [ lineData,setLineData ] = useState([]);
  const lineChartAPI = async() => {
    const DATA = { PARTNER_CD:partner.COMN_CD, START_DATE:format(startDate, 'yyyyMMdd'), END_DATE:format(endDate, 'yyyyMMdd') };
    const result = await axiosPostHandler(`partnerLineChartForPartner.do`, DATA);
    if(!result || result.message !== "SUCCESS") { return; }
    if(result.message === "SUCCESS") {
      setLineData(result.data);
    }
  }
  useEffect(() => {(async () => {
    if(!isState) { return; }
    
    lineChartAPI();
  })()}, [isState, startDate, endDate, socket]);
  /* =============== 기간별 매출통계 =============== */
  /* =============== 차트hover툴팁 =============== */
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className={styles.tooltipArea}>
          <div><span>이용 건수</span><label>{new Intl.NumberFormat('en').format(payload[0].payload.cnt)}건</label></div>
          <div><span>매출액</span><label>{new Intl.NumberFormat('en').format(payload[0].payload.totBalance)}원</label></div>
        </div>
      );
    }
    return null;
  };
  /* =============== 차트hover툴팁 =============== */
  /* =============== 차트YAxis넓이동적적용 =============== */
  const [width, setWidth] = useState(0);
  useEffect(() => {
    (async () => {
      if (lineData.length > 0) {
        const label = lineData.map((item) => {
          return item.balance;
        }).reduce((acc, cur) => {
          return cur?.toString()?.length > acc?.toString()?.length ? cur : acc;
        }, {})
        setWidth((label?.toString()?.length + 2) * 2);
      }
    }
    )();
  }, [lineData]);
  /* =============== 차트YAxis넓이동적적용 =============== */

  class MemberReservCountLineChart extends PureComponent {
    render() {
      return (
        <div className={[styles.chartContainer, styles.lineChartContainer].join(" ")}>
          <h1><span>매출 현황</span><small>(단위:만원)</small></h1>
          <div>
            <ResponsiveContainer>
              <ComposedChart width={"100%"} height={456} data={lineData}>
                  <defs>
                    <linearGradient id="colorVolumn" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="12.7%" stopColor="#FFD400" stopOpacity={.1} />
                      <stop offset="99%" stopColor="#191A1A" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid stroke="#373737" vertical={false} />
                  <XAxis stroke="#A1A1A1" fontSize={12} tickLine={false} unit="" dataKey="name" scale="point" padding="gap" />
                  <YAxis type="number" tickCount={7} stroke="#A1A1A1" fontSize={12} tickLine={false} width={width} tickFormatter={(value) => new Intl.NumberFormat("en-US", { compactDisplay: "short" }).format(value)} />
                  <Tooltip content={<CustomTooltip />} cursor={{ stroke: "#FFF", strokeWidth: 1, strokeDasharray: "5 5", strokeOpacity: .8 }} />
                  <Bar dataKey="cnt" fill="#737373" barSize={20} radius={[4, 4, 0, 0]} />
                  <Area type="monotone" dataKey="balance" stroke="#FFD400" strokeWidth={2} fillOpacity={1} fill="url(#colorVolumn)" name="매출액" />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </div>
      )
    }
  } return (<MemberReservCountLineChart />)
})